import { Trans } from '@lingui/react/macro';
import { Typography } from '@remarkable/ark-web';

import {
  useCheckoutAllowedSuspense,
  useDevicesSuspense,
} from 'src/api/queries';
import { Divider, Link } from 'src/components';
import { URLS } from 'src/utils/urls/urls';

import { ComponentLocations } from 'src/analytics/trackingTypes';
import { ConnectOfferInfo } from './ConnectOfferInfo';
import { NoSubscriptionNotPairedDeviceCard } from './NoSubscriptionNotPairedDeviceCard';
import { NoSubscriptionPairedDeviceCard } from './NoSubscriptionPairedDeviceCard';

export const NoSubscriptionDetails = () => {
  const devices = useDevicesSuspense();
  const checkoutAllowed = useCheckoutAllowedSuspense();
  const connectOfferAllowedStatus = checkoutAllowed.data?.connectOffer;
  const dmOfferAllowedStatus = checkoutAllowed.data?.dmOffer;
  const winbackOfferAllowedStatus = checkoutAllowed.data?.winbackOffer;

  const hasDevices = !!devices.data?.length;

  if (connectOfferAllowedStatus?.allowed) {
    return (
      <ConnectOfferInfo
        offerType="connectOffer"
        expiresAt={connectOfferAllowedStatus.expiresAt}
        freeTrialLengthDays={connectOfferAllowedStatus.freeTrialLengthDays}
      />
    );
  }

  if (dmOfferAllowedStatus?.allowed) {
    return (
      <ConnectOfferInfo
        offerType="dmOffer"
        expiresAt={dmOfferAllowedStatus.expiresAt}
        freeTrialLengthDays={dmOfferAllowedStatus.freeTrialLengthDays}
      />
    );
  }

  if (winbackOfferAllowedStatus?.allowed) {
    return (
      <ConnectOfferInfo
        offerType="winbackOffer"
        expiresAt={winbackOfferAllowedStatus.expiresAt}
        freeTrialLengthDays={winbackOfferAllowedStatus.freeTrialLengthDays}
      />
    );
  }

  return (
    <>
      <Typography as="h2" variant="body-2xl" fontWeight="bold">
        <Trans>You have no active subscription</Trans>
      </Typography>

      <Divider />

      <Typography as="p" variant="body-md">
        <Trans>
          Get unlimited cloud storage, seamless integrations, handwriting
          search, and a growing list of tools built to suit your workflow.
        </Trans>{' '}
        <Link
          inline
          to={URLS.STORE_CONNECT_LANDING}
          trackingLocation={ComponentLocations.SUBSCRIPTION.PLAN_PAGE}
        >
          <Trans>Read more</Trans>
        </Link>
      </Typography>

      {hasDevices ? (
        <NoSubscriptionPairedDeviceCard />
      ) : (
        <NoSubscriptionNotPairedDeviceCard />
      )}
    </>
  );
};
